import log, { LoggingLevel } from "../../core/log.js";
import Uploader from "../../core/upload/uploader.js";
import BrowserFetchUploader from "./fetch_uploader.js";
import BrowserSendBeaconUploader from "./sendbeacon_uploader.js";
import { Context } from "../../core/context.js";
const LOG_TAG = "platform.browser.SendBeaconFallbackUploader";
class BrowserSendBeaconFallbackUploader extends Uploader {
    constructor() {
        super(...arguments);
        this.fetchUploader = BrowserFetchUploader;
        this.sendBeaconUploader = BrowserSendBeaconUploader;
    }
    async post(url, pingRequest) {
        var _a, _b;
        const hasNoCustomHeaders = !((_a = Context.config) === null || _a === void 0 ? void 0 : _a.sourceTags) && !((_b = Context.config) === null || _b === void 0 ? void 0 : _b.debugViewTag);
        if (hasNoCustomHeaders && !!navigator && !!navigator.sendBeacon) {
            const beaconStatus = await this.sendBeaconUploader.post(url, pingRequest, false);
            if (beaconStatus.result == 2) {
                return beaconStatus;
            }
            log(LOG_TAG, "The `sendBeacon` call was not serviced by the browser. Falling back to the `fetch` uploader.", LoggingLevel.Warn);
        }
        else {
            log(LOG_TAG, "`sendBeacon` is not available. Falling back to the `fetch` uploader.", LoggingLevel.Warn);
        }
        return this.fetchUploader.post(url, pingRequest);
    }
    supportsCustomHeaders() {
        return false;
    }
}
export default new BrowserSendBeaconFallbackUploader();
